import { apiPost } from "../client";
import { useMutation } from "@tanstack/react-query";
import type { IExamProgress } from "./types";
import type { IApiResponse } from "../client";

export async function apiStartExamPaper(
  progressId: string,
  examPaperId: string
): Promise<IApiResponse<IExamProgress>> {
  return apiPost(
    `/exam_progress/${progressId}/exam_paper/${examPaperId}/start`
  );
}

export function useMutationStartExamPaper() {
  return useMutation({
    mutationFn: ({
      progressId,
      examPaperId,
    }: {
      progressId: string;
      examPaperId: string;
    }) => apiStartExamPaper(progressId, examPaperId),
  });
}
